import * as React from "react";
const SvgZoomIn = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M40 40h-3m14 11-6-6zm-4-11a7.001 7.001 0 0 1-11.95 4.95A6.998 6.998 0 0 1 40 33a7 7 0 0 1 7 7m-7-3v3zm0 3v3zm0 0h3z"
    />
  </svg>
);
export default SvgZoomIn;
